import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import ConsoleWrapper from '../../../components/endpoints-page/console';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h2>{`Channel Search Endpoint`}</h2>
    <p>{`Channel Search endpoint returns all the GIPHY channels matching the query term`}</p>
    <ConsoleWrapper mdxType="ConsoleWrapper">
      <table>
        <thead parentName="table">
          <tr parentName="thead">
            <th parentName="tr" {...{
              "align": "left"
            }}>{`URL`}</th>
          </tr>
        </thead>
        <tbody parentName="table">
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}>{`api.giphy.com/v1/channels/search`}</td>
          </tr>
        </tbody>
      </table>
    </ConsoleWrapper>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Request Parameters:`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Example:`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description:`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`api_key`}</strong>{`: `}<em parentName="td">{`string(required)`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`YOUR_API_KEY`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`GIPHY API Key.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`q`}</strong>{`: `}<em parentName="td">{`string(required)`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`foo`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Accepts term to search through GIPHY’s channels`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`limit:`}</strong>{` `}<em parentName="td">{`integer (int32)`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`20`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The maximum number of objects to return.`}<br />{` Default: “25”`}<br />{` Maximum: “50”`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`offset:`}</strong>{` `}<em parentName="td">{`integer (int32)`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`5`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Specifies the starting position of the results.`}<br />{` Default: “0”`}<br /></td>
        </tr>
      </tbody>
    </table>
    <h5>{`Successful Response (200 OK)`}</h5>
    <ConsoleWrapper mdxType="ConsoleWrapper">
    <ul>
        <li>
            data: <a href="/docs/api/schema#channel-object">Channel Object[]</a>
        </li>
        <li>
            pagination: <a href="/docs/api/schema#pagination-object">Pagination Object</a>
        </li>
        <li>
            meta: <a href="/docs/api/schema#meta-object">Meta Object</a>
        </li>
    </ul>
    </ConsoleWrapper>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      